import CreatedLead from './CreatedLead'
export default CreatedLead